import { render, staticRenderFns } from "./active-phone.vue?vue&type=template&id=428098bb"
import script from "./active-phone.vue?vue&type=script&lang=js"
export * from "./active-phone.vue?vue&type=script&lang=js"
import style0 from "./active-phone.vue?vue&type=style&index=0&id=428098bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports